<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            打卡记录列表
        </div>
        <div style="padding: 20px;">

            <div>

                <el-row>
                    <div style="float:right">
                        <el-input  placeholder="请输入地点名称" v-model="searchBuild" clearable @change="getList" style="margin:0 10px;width:200px"></el-input>
                        <el-date-picker
                            v-model="startTime"
                            type="date"
                            style="margin-right:10px;"
                            value-format="yyyy-MM-dd"
                            placeholder="开始日期">
                        </el-date-picker>
                        <el-date-picker
                            v-model="endTime"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="结束日期">
                        </el-date-picker>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                    </div>
                </el-row>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">


                        <el-table-column prop="user.name" label="姓名"></el-table-column>
                        <el-table-column prop="user.userType" label="用户类型">
                            <template slot-scope="scorp">
                                <span v-if="scorp.row.user.userType==3">医生</span>
                                <span v-if="scorp.row.user.userType==4">护士</span>
                                <span v-if="scorp.row.user.userType==5">护工</span>
                                <span v-if="scorp.row.user.userType==6">员工</span>
                                <span v-if="scorp.row.user.userType==7">保安</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="user.departmentName" label="部门"></el-table-column>
                        <el-table-column label="图片">
                            <template slot-scope="scorp">
                                <el-popover
                                    placement="right"
                                    :width="400"
                                    trigger="hover">
                                    <el-image :src="imgUrl+scorp.row.imgPath+'_watermark.jpg'"></el-image>
                                    <template slot='reference'>
                                        <el-button><i class="el-icon-picture"></i></el-button>
                                    </template>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                        <el-table-column prop="name" label="巡逻地点"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" label="巡逻时间"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr,getBeforeDate,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,

                showModalAdd:false,
                showModalEdit:false,
                searchBuild:'',
                clockinPointCode:"",
                clockinPointValue:[],
                startTime:getBeforeDate(-30),
                endTime:getBeforeDate(0),
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                imgUrl:this.$imgUrl,
                th:0,

            }
        },
        created(){
            this.getList();
            this.getClockinPointList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            toggleModalEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit:function(){
                this.showModalEdit = !this.showModalEdit;
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
            getList(){

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"PatrolPointRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.searchBuild,
                        startTime:this.startTime,
                        endTime:this.endTime,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getClockinPointList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"ClockinPoint/List",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    if(response.data.error == 0){
                        this.clockinPointValue = response.data.data;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            }


        }
    }
</script>

<style scoped>

</style>
